<div class="builder__item">
  <div class="builder__item__title">{{ title }}</div>
  <div class="builder__item__body">
    <ng-content></ng-content>
  </div>
</div>
